import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import i18n, { loadLanguages } from "./i18n";
import quote from "./quote";
import { cacheInviteParams } from "./recovered/wallet-session";
import { clearLegacyTokenStorage } from "./recovered/token-session";

Vue.use(i18n);
Vue.use(quote);
Vue.config.productionTip = false;

clearLegacyTokenStorage();

// 落地即捕获邀请参数（?invite= 用户邀请码 / ?tx= 代理邀请码 等），存入 localStorage 供注册时使用
cacheInviteParams();

// 拉后台启用的语言列表；不阻塞挂载，失败则继续用内置清单
loadLanguages();

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
